import actionTypes from './actionTypes';

export const initialState = {
  alert: null,
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.ALERT_DISMISS:
      return {
        ...state,
        alert: null,
      };
    case actionTypes.ALERT_SET:
      return {
        ...state,
        alert: action.alert,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/alert/reducer.js